module.exports = __webpack_public_path__ + "static/media/blog3.2e8badf9.jpg";